import React,{useEffect,useState} from "react";
import {IconButton, Menu, MenuItem} from "@mui/material";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import MDBox from "../../../../../../components/MDBox";
import TabPageHeader from "../../header/tabpageheader";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import RefreshIcon from "@mui/icons-material/Refresh";
import {getFields} from "../../../../../dialog/formfields";
import GenericForm from "../../../../../dialog/genericform";
import DataTableConfig from "../../../../../Tables/DataTableConfig";
import PropTypes from "prop-types";
import tableData from "../../../../../tabledata";
import useConfigApi from "../../../../../utils/configapi";
import Endpoints from "../../../../../utils/endpoints";
import toast from "react-hot-toast";



const CardConfig = ({ selectedRowData }) => {
    const { cardConfigColumns } = tableData();
    const { cardConfigFields, cardConfigSchema } = getFields();
    const [cardConfig, setCardConfig] = useState([]);
    const [anchorEl, setAnchorEl] = useState(null);
    const [activeRowIndex, setActiveRowIndex] = useState(null);
    const [isModalOpen, setModalOpen] = useState(false);
    const [dialogData, setDialogData] = React.useState(null);
    const [dialogMode, setDialogMode] = React.useState("edit");
    const [dialogTitle, setDialogTitle] = React.useState("Create CardConfig");
    const api = useConfigApi();

    const handleClick = () => {
        setDialogMode("create");
        setDialogData({});
        setModalOpen(true);
        setDialogTitle("Create CardConfig");

    };

    const closeModal = () => {
        setModalOpen(false);
        setDialogData(null);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
        setActiveRowIndex(null);
    };

    const handleMenuOpen = (event, index) => {
        setAnchorEl(event.currentTarget);
        setActiveRowIndex(index);
    };

    const handleActionClick = (action: string, item) => {
        const row = cardConfig[activeRowIndex];
        if(action === 'View'){
            setModalOpen(true);
            setDialogMode("view");
            setDialogData(row);
            setDialogTitle("View CardConfig");
        } else if (action === 'Edit') {
            setModalOpen(true);
            setDialogMode("edit");
            setDialogTitle("Edit CardConfig");
            setDialogData(row);
        } else if (action === 'Delete') {
            setModalOpen(true);
            setDialogMode("delete");
            setDialogTitle("Delete CardConfig");
            setDialogData(row);
        }
        handleMenuClose();
    };

    const handleDialogSubmit = (formData) => {
      console.log("Raw Input:", formData.terminalWorkingKey);
      console.log("Submitted data:", formData, dialogMode);
      console.log("manualEntryEnabled:", formData.manualEntryEnabled, typeof formData.manualEntryEnabled);
      console.log("fallback_allow:", formData.fallbackAllow, typeof formData.fallbackAllow);
        formData.controlConfigSerialNumber  = selectedRowData.slNo;
        // Call your API here
        if (dialogMode === "create") {
          // Handle create logic here
          api.post(Endpoints.cardConfig.createOrUpdate, formData)
            .then((response) => {
              toast.success("Card config successfully created.");
              fetchCardConfigs(); // Fetch the latest data after creation
            })
            .catch((error) => {
              toast.error("Internal error occurred while creating.");
            });
        } else if (dialogMode === "edit") {
          api.put(Endpoints.cardConfig.createOrUpdate, formData)
            .then(() => {
              toast.success("Card config successfully updated.");
              setCardConfig((prevRows) =>
                prevRows.map((row, index) =>
                  index === activeRowIndex ? { ...row, ...formData } : row
                )
              );
              fetchCardConfigs();
            })
            .catch(() => toast.error("Internal error occurred while updating."));
        }
    };

    const handleDialogDelete = (formData) => {
        if (!formData.slNo) {
            toast.error("Missing slNo for deletion.");
            return;
        }
        api.delete(Endpoints.cardConfig.deleteBySlNo(formData.slNo))
            .then(() => {
                toast.success(`Card config ${formData.slNo} successfully deleted.`);
                fetchCardConfigs();
            })
            .catch(() => {
                toast.error("Error deleting header config.");
            });
    };

    useEffect(() => {
        fetchCardConfigs();
    },[]);

    const fetchCardConfigs = () => {
        api.get(Endpoints.cardConfig.getByControlSlNo(selectedRowData.slNo))
            .then((response) => {
                const data = response?.data.data || [];
                const modifiedData = data.map((item, index) => {
                    const action = (
                        <>
                            <IconButton onClick={(e) => handleMenuOpen(e, index)}>
                                <MoreHorizIcon />
                            </IconButton>
                        </>
                    );
                    return { ...item, action };
                });
                setCardConfig(modifiedData);
            })
            .catch((error) => {
                toast.error("Error while fetching records.");
            });
    };

    return (
      <>
        <MDBox
          sx={{
            px: 3,
            py: 2,
            bgcolor: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <TabPageHeader
            title="Card Config"
            showButton={true}
            buttonLabel="Add"
            onButtonClick={handleClick}
          />
        </MDBox>
        <MDBox
          sx={{
            px: 3,
            py: 2,
            bgcolor: "#fff",
            borderBottom: "1px solid #d3e3fd",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            overflowX: "auto",
            width: "100%",
          }}
        >
          <DataTableConfig
            table={{ columns: cardConfigColumns, rows: cardConfig }}
            showTotalEntries={true}
            isSorted={true}
            noEndBorder
            entriesPerPage={true}
            canSearch={true}
          />
        </MDBox>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
          onClick={handleMenuClose}
        >
          <MenuItem onClick={() => handleActionClick("View")}>
            <IconButton size="small">
              <i className="material-icons">visibility</i>
            </IconButton>
            View
          </MenuItem>
          <MenuItem onClick={() => handleActionClick("Edit")}>
            <IconButton size="small">
              <EditIcon fontSize="small" />
            </IconButton>
            Edit
          </MenuItem>
          <MenuItem onClick={() => handleActionClick("Delete")}>
            <IconButton size="small" color="error">
              <DeleteIcon fontSize="small" />
            </IconButton>
            Delete
          </MenuItem>
          {/*<MenuItem onClick={() => handleActionClick("Sync")}>*/}
          {/*    <IconButton size="small" color="error">*/}
          {/*        <RefreshIcon fontSize="small" />*/}
          {/*    </IconButton>*/}
          {/*    Sync*/}
          {/*</MenuItem>*/}
        </Menu>
        <GenericForm
          open={isModalOpen}
          handleClose={closeModal}
          title={dialogTitle}
          fields={cardConfigFields}
          onSubmit={handleDialogSubmit}
          onDelete={handleDialogDelete}
          initialData={dialogData}
          mode={dialogMode}
          useDialog={true}
          validationSchema={cardConfigSchema} // ✅ THIS IS CRITICAL
        />
      </>
    );
};
CardConfig.propTypes = {
    selectedRowData: PropTypes.shape({
        controlName: PropTypes.string,
        controlType: PropTypes.string,
        slNo: PropTypes.number,
    }),
};
export default CardConfig;
